export default "__VITE_ASSET__b32ab59c__"